<template>
  <section class="hero is-light is-fullheight">
    <div class="hero-body">
      <div class="container">
        <form>
          <div class="columns is-centered">
            <div class="column is-5-tablet is-4-desktop is-3-widescreen">
              <form @submit.prevent="submit" class="box p-6">
                <div class="has-text-centered mb-5">
                  <h1 class="title has-text-grey-dark">Welcome</h1>
                  <p class="subtitle is-6">Please login to your account</p>
                </div>

                <!-- Username Field -->
                <div class="field">
                  <label class="label">Username</label>
                  <div class="control has-icons-left">
                    <input 
                      v-model="form.username" 
                      class="input" 
                      type="text" 
                      placeholder="e.g. admin" 
                      required
                      autocomplete="username"
                    >
                    <span class="icon is-small is-left">
                      <i class="fas fa-user"></i>
                    </span>
                  </div>
                </div>

                <!-- Password Field -->
                <div class="field">
                  <label class="label">Password</label>
                  <div class="control has-icons-left">
                    <input 
                      v-model="form.password" 
                      class="input" 
                      type="password" 
                      placeholder="*******" 
                      required
                      autocomplete="current-password"
                    >
                    <span class="icon is-small is-left">
                      <i class="fas fa-lock"></i>
                    </span>
                  </div>
                </div>

                <!-- Error Message -->
                <div v-if="errorMessage" class="notification is-danger is-light is-small py-2 mt-3">
                  {{ errorMessage }}
                </div>

                <!-- Submit Button -->
                <div class="field mt-5">
                  <button 
                    type="submit" 
                    class="button is-primary is-fullwidth has-text-weight-bold"
                    :class="{ 'is-loading': isLoading }"
                  >
                    Sign In
                  </button>
                </div>
              </form>
            </div>
          </div>
        </form>
      </div>
    </div>
  </section>
</template>

<script setup>
import { reactive, ref } from 'vue';
import { handleLogin } from '@/services/auth';

const form = reactive({ username: '', password: '' });
const errorMessage = ref('');
const isLoading = ref(false);

const submit = async () => {
  isLoading.value = true;
  errorMessage.value = '';
  try {
    await handleLogin(form);
  } catch (err) {
    errorMessage.value = 'Invalid username or password';
  } finally {
    isLoading.value = false;
  }
};
</script>

<style scoped>
/* Optional: Soften the background or add a subtle gradient */
.hero.is-light {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}
.box {
  box-shadow: 0 10px 25px rgba(0,0,0,0.1);
  border-radius: 8px;
}
</style>
